import moment from 'moment';

const isHour = (time, hour) => moment.utc(time).hour() === hour;

export default timeSlots => timeSlots.filter(slot => !(isHour(slot.startDatetime, 8) && isHour(slot.endDatetime, 17)));
